<template>
  <section
    class="invoice-preview-wrapper"
    style="position: relative"
  >
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="order === undefined"
    >
      <h4 class="alert-heading">
        Error fetching invoice data
      </h4>
      <div class="alert-body">
        No invoice found with this invoice id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'facture-list' }"
        >
          invoice List
        </b-link>
        for other invoice.
      </div>
    </b-alert>

    <b-row
      v-if="order"
      class="invoice-preview"
    >
      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <b-row
            style="border: 1px solid black; border-radius: 18px; padding: 10px"
          >
            <!-- Header: Left Content -->

            <b-col
              cols="12"
              md="12"
              style="color: black; font-size: 18px; text-align: center"
            >
              <img
                src="@/assets/images/logo/logo.png"
                width="150px"
                height="auto"
              >
              <div
                style="color: black; font-size: 40px"
                class="font-weight-bolder"
              >
                GROUPES SERVICES RAPIDES
                <div style="font-size: 28px">
                  Vente tous genre de cléfs brut, machines et accessoires
                </div>
              </div>

              <b-card-text
                style="font-size: 20px"
                class="font-weight-bold mt-1"
              >
                <div>RUE EL KOUNAITRA 1-dar Chaabene El Fehri</div>
                <div class="mt-1">
                  Tel: +216 97 607 740 , Email: gsr-cle1@hotmail.fr
                </div>

                <div class="mt-1 mb-1">
                  MF : 1082793 F/A/M/000 | C.D 837979P
                </div>
                <div class="mt-1 mb-1">
                  Curency: {{ order.currency }}
                </div>
              </b-card-text>
            </b-col>
          </b-row>
          <div class="mt-1">
            <b-row style="color: black">
              <b-col
                cols="8"
                md="8"
                sm="12"
              >
                <h3
                  class="font-weight-bolder"
                  style="
                    color: black;
                    font-size: 28px;
                    border: 1px solid black;
                    padding: 10px;
                    text-align: center;
                  "
                >
                  FACTURE
                </h3>
                <div class="mt-1 d-flex">
                  <table style="border: 1px solid black">
                    <tr
                      style="
                        color: black;
                        font-size: 20px;
                        border: 1px solid black;
                      "
                    >
                      <th
                        style="text-align: center"
                        class="font-weight-bolder"
                      >
                        N° du pièce
                      </th>
                    </tr>
                    <tr
                      style="
                        color: black;
                        font-size: 20px;
                        border: 1px solid black;
                      "
                    >
                      <td
                        v-if="order"
                        style="text-align: center"
                        class="font-weight-bolder"
                      >
                        {{ order.number }}
                      </td>
                    </tr>
                  </table>
                  <table style="border: 1px solid black; margin-left: 10px">
                    <tr
                      style="
                        color: black;
                        font-size: 20px;
                        border: 1px solid black;
                      "
                    >
                      <th
                        style="text-align: center"
                        class="font-weight-bolder"
                      >
                        Date
                      </th>
                    </tr>
                    <tr
                      style="
                        color: black;
                        font-size: 20px;
                        border: 1px solid black;
                      "
                    >
                      <td
                        v-if="order"
                        style="text-align: center"
                        class="font-weight-bolder"
                      >
                        {{ format(order.date) }}
                      </td>
                    </tr>
                  </table>
                </div>
              </b-col>
              <b-col
                v-if="order.supplier"
                cols="4"
                md="4"
                sm="12"
                style="
                  border: 1px solid black;
                  border-radius: 18px;
                  font-size: 14px;
                  padding: 10px;
                  background-color: #eeede9;
                "
              >
                <!-- Header: Left Content -->
                <div style="color: black; font-size: 20px">
                  <h4
                    style="color: black; font-size: 20px"
                    class="mb-1 font-weight-bolder"
                  >
                    Fournisseur : {{ order.supplier.company_name }}
                  </h4>
                  <span class="mb-0 mt-1 font-weight-bold">
                    Adresse : {{ order.supplier.address }}
                  </span>
                  <b-card-text class="mb-0 mt-1 font-weight-bold">
                    MF : {{ order.supplier.tax_identification_number }}
                  </b-card-text>
                </div>

                <!-- Header: Right Content -->
                <!-- Header: Right Content -->
              </b-col>
            </b-row>
          </div>
          <!-- Invoice Description: Table -->
          <table class="container-products mt-2">
            <b-table-lite
              responsive
              :items="p"
              :small="true"
              :fields="[
                'N°',
                'Qté',
                'Label',
                'Prix Achat',
                'Total prix achat',
                'Prix Vente',
                'Total prix vente',
              ]"
              class="ta font-weight-bold mt-1"
            >
              <template #cell(taskDescription)="data">
                <b-card-text
                  class="font-weight-bold mb-25"
                  style="font-size: 25px; border: 2px solid black !important"
                >
                  {{ data.item.taskTitle }}
                </b-card-text>
                <b-card-text class="text-nowrap">
                  {{ data.item.taskDescription }}
                </b-card-text>
              </template>
            </b-table-lite>
          </table>
          <!-- Invoice Description: Total -->

          <div>
            <b-row class="card-body">
              <b-col
                cols="6"
                md="6"
                xl="6"
                sm="12"
                style="
                  border: 1px solid black;
                  padding: 10px,
                  border-radius: 18px;
                "
              >
                <span
                  class="font-weight-bolder mt-1"
                  style="
                    color: black;
                    border-bottom: 1px solid black;
                    font-size: 20px;
                  "
                >
                  Arreteé la présente facture a la somme de
                </span>
                <br><br>
                <span
                  class="font-weight-bold mt-1"
                  style="color: black; font-size: 20px"
                >
                  {{ lettre }}
                </span>
                <!-- <div v-html="order.note" /> -->
              </b-col>
              <b-col cols="1" />
              <b-col
                cols="5"
                md="5"
                xl="5"
                sm="12"
                class="p-0"
                style="
                  border: 1px solid black;
                  padding: 10px;
                  border-radius: 18px;
                "
              >
                <table class="border-pricing m-1">
                  <tbody>

                    <tr style="color: black; font-size: 20px">
                      <th
                        scope="row"
                        class="border-pricing"
                      >
                        Total prix achat :
                      </th>
                      <td class="font-weight-bold border-pricing">
                        {{ (Number(order.price_ttc)).toFixed(3) }}
                      </td>
                    </tr>
                    <tr style="color: black; font-size: 20px">
                      <th
                        scope="row"
                        class="border-pricing"
                      >
                        Total prix vente :
                      </th>
                      <td class="font-weight-bold border-pricing">
                        {{ (Number(order.price_sales)).toFixed(3) }}
                      </td>
                    </tr>

                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row class="card-body text-center">
              <b-col
                cols="6"
                md="6"
                xl="6"
                sm="12"
              >
                <h5 style="color: black; font-size: 16px">
                  Signature
                </h5>
              </b-col>
            </b-row>
          </div></b-card>
      </b-col>
      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>
          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Print
          </b-button>

          <!-- Button: Edit -->
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import axiosIns from '@/libs/axios'

import {
  BRow,
  BCol,
  BCard,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import { NumberToLetter } from 'convertir-nombre-lettre'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
  },
  data() {
    return {
      p: [],
      order: [],
      lettre: '',
      id: null,
    }
  },

  created() {
    this.id = this.$route.params.id
    this.getPurchaseOrder()
  },
  methods: {
    format(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    async getPurchaseOrder() {
      const { data } = await axiosIns.get(`/purchase-orders/details/${this.id}/`)
      this.order = data
      const sommeString = this.order.price_ttc.toString()
      if (sommeString.includes('.000') === true) {
        this.lettre = `${NumberToLetter(this.order.price_ttc)} Dinars `
      } else {
        const [dinar, milim] = this.order.price_ttc.split('.')
        this.lettre = `${NumberToLetter(dinar)} Dinars , ${NumberToLetter(
          milim,
        )} Millimes`
      }
      this.getProducts()
    },

    async getProducts() {
      const { data } = await axiosIns.post('/purchase-orders-products/details/',
        {
          order: Number(this.id),
        })
      for (let i = 0; i < data.length; i += 1) {
        this.addnewitem(
          i + 1,
          data[i].quantity,
          data[i].label,
          data[i].purchase_price_ttc,
          data[i].total_purchase_ttc,
          data[i].sales_price_ttc,
          data[i].total_sales_ttc,
        )
      }
    },

    // eslint-disable-next-line camelcase
    addnewitem(
      nb,
      quantity,
      label,
      purchase_price_ttc,
      total_purchase_ttc,
      sales_price_ttc,
      total_sales_ttc,

    ) {
      this.p.push({
        Qté: quantity,
        Label: label,
        'Prix Achat': purchase_price_ttc,
        'Total prix achat': total_purchase_ttc,
        'Prix Vente': sales_price_ttc,
        'Total prix vente': total_sales_ttc,
        'N°': nb,
      })
    },
  },
  setup() {
    const printInvoice = () => {
      window.print()
    }

    return {
      printInvoice,
    }
  },
}
</script>

<style lang="scss">
@media print {
  html, body {
    height: 99%;
  }
  @page {
    size: A4;
  }

  .ta {
    overflow-x: visible;
    font-size: 18px;
    color: black;
  }

  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: auto; /* Footer height */
  }

  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  .mycolor {
    background-color: #208a9d;
    -webkit-print-color-adjust: exact;
  }
  .contact {
    background-color: #208a9d;
    padding: 20px;
    border-radius: 25px;
    -webkit-print-color-adjust: exact;
  }
  footer footer-light footer-static {
    display: inline-block;
  }
  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
  * {
    color: black !important;
  }

  .border-pricing {
    text-align: left;
    border: 0px solid black;
  }

}
@import "~@core/scss/base/pages/app-invoice.scss";
.trborder {
  border-bottom: 0px solid black;
}
footer {
  bottom: 0;
  height: auto; /* Footer height */
}
.container-products{
  min-height: 500px;
  border: 1px solid black;
}
table {
  width: 100%;
  border-collapse: collapse;
}
.mycolor {
  background-color: #208a9d;
}
.contact {
  background-color: #208a9d;
  padding: 10px;
  border-radius: 20px;
}
</style>
